export default {
  ND: 'ND',
  FD: 'FD',
  POTENTIAL: 'POTENTIAL',
};
